module.exports = __webpack_public_path__ + "img/60d9724.jpg";